import type { AuthTranslations } from './types'

/**
 * Urdu translations for Auth domain
 */
export const urTranslations: AuthTranslations = {
  // Page/Section level
  title: "تصدیق",
  subtitle: "تصدیق کی ترتیبات کا انتظام کریں",

  // Actions
  addAuth: "تصدیق شامل کریں",
  editAuth: "تصدیق میں ترمیم کریں",
  deleteAuth: "تصدیق حذف کریں",

  // Search and filters
  searchPlaceholder: "تصدیق تلاش کریں...",
  noItemsFound: "کوئی تصدیق آئٹم نہیں ملا",
  noItemsDescription: "آپ نے ابھی تک کوئی تصدیق آئٹم شامل نہیں کیا۔ شروع کرنے کے لیے اپنا پہلا آئٹم شامل کریں۔",
  addFirst: "اپنی پہلی تصدیق شامل کریں",

  // Form section (basic)
  form: {
    name: "نام",
    namePlaceholder: "نام درج کریں",
    status: "حالت",
    validation: {
      nameRequired: "نام درکار ہے",
    }
  },

  // Status
  status: {
    active: "فعال",
    inactive: "غیر فعال",
  },

  // Messages
  messages: {
    createSuccess: "تصدیق کامیابی سے بنائی گئی",
    updateSuccess: "تصدیق کامیابی سے اپ ڈیٹ ہوئی",
    deleteSuccess: "تصدیق کامیابی سے حذف ہوئی",
    deleteConfirm: "کیا آپ واقعی اس تصدیق کو حذف کرنا چاہتے ہیں؟",
  },

  // Table headers
  table: {
    name: "نام",
    status: "حالت",
  },

  // Login page
  signIn: "سائن ان",
  signUp: "سائن اپ",
  welcomeBack: "خوش آمدید",
  loginSubtitle: "اپنے بوابة الجنوب کسٹمر پورٹل میں سائن ان کریں",
  enterCredentials: "اپنے اکاؤنٹ تک رسائی کے لیے اپنی معلومات درج کریں",
  rememberMe: "مجھے یاد رکھیں",
  forgotPassword: "پاس ورڈ بھول گئے؟",
  forgotPasswordDescription: "اپنا ای میل ایڈریس درج کریں اور ہم آپ کو پاس ورڈ ری سیٹ لنک بھیجیں گے",
  noAccount: "اکاؤنٹ نہیں ہے؟",
  alreadyHaveAccount: "پہلے سے اکاؤنٹ ہے؟",

  // Registration
  createAccount: "اکاؤنٹ بنائیں",
  registerSubtitle: "آج ہی بوابة الجنوب کسٹمر پورٹل میں شامل ہوں",
  registrationSuccessful: "رجسٹریشن کامیاب",
  registrationSuccessMessage: "آپ کا اکاؤنٹ کامیابی سے بنایا گیا",
  registrationPendingMessage: "رجسٹریشن کا شکریہ۔ آپ کا اکاؤنٹ منظوری کے منتظر ہے اور منظوری کے بعد آپ سائن ان کر سکیں گے۔",
  fillDetails: "اکاؤنٹ بنانے کے لیے اپنی تفصیلات بھریں",
  fullName: "پورا نام",
  fullNamePlaceholder: "اپنا پورا نام درج کریں",
  companyName: "کمپنی کا نام",
  companyNamePlaceholder: "اپنی کمپنی کا نام درج کریں",
  phone: "فون نمبر",
  phonePlaceholder: "+966 5XX XXX XXXX",
  accountType: "اکاؤنٹ کی قسم",
  selectAccountType: "اکاؤنٹ کی قسم منتخب کریں",
  accountContractor: "ٹھیکیدار",
  accountSupplier: "سپلائر",
  accountDistributor: "ڈسٹری بیوٹر",
  accountRetail: "ریٹیل کسٹمر",

  // Terms
  termsNotice: "جاری رکھ کر، آپ ہماری سے اتفاق کرتے ہیں",
  termsOfService: "سروس کی شرائط",
  privacyPolicy: "رازداری کی پالیسی",
  and: "اور",
  agreeToTerms: "میں متفق ہوں",

  // Password reset
  resetPassword: "پاس ورڈ ری سیٹ کریں",
  resetSubtitle: "ہم آپ کو آپ کے اکاؤنٹ میں واپس جانے میں مدد کریں گے",
  resetInstructions: "اپنا ای میل ایڈریس درج کریں اور ہم آپ کو پاس ورڈ ری سیٹ کرنے کا لنک بھیجیں گے",
  sendResetLink: "ری سیٹ لنک بھیجیں",
  backToLogin: "لاگ ان پر واپس جائیں",
  checkEmail: "اپنا ای میل چیک کریں",
  resetEmailSent: "ری سیٹ ای میل بھیج دیا گیا",
  resetEmailSentMessage: "ہم نے {{email}} پر پاس ورڈ ری سیٹ لنک بھیج دیا ہے",
  didntReceiveEmail: "ای میل نہیں ملا؟ اپنا سپیم فولڈر چیک کریں یا دوبارہ کوشش کریں۔",
  tryAgain: "دوبارہ کوشش کریں",
  passwordResetSuccessful: "پاس ورڈ ری سیٹ کامیاب",
  passwordResetSuccessMessage: "آپ کا پاس ورڈ کامیابی سے ری سیٹ ہو گیا",
  resetPasswordDescription: "نیچے اپنا نیا پاس ورڈ درج کریں",
  newPassword: "نیا پاس ورڈ",
  currentPassword: "موجودہ پاس ورڈ",

  // Toasts / notifications
  loginSuccess: "لاگ اِن کامیاب",
  loginSuccessMessage: "خوش آمدید",
  loginError: "لاگ اِن ناکام",
  registerSuccess: "رجسٹریشن کامیاب",
  registerError: "رجسٹریشن ناکام",
  logoutSuccess: "لاگ آؤٹ ہو گیا",
  logoutSuccessMessage: "آپ لاگ آؤٹ ہو گئے ہیں",
  passwordResetSent: "ری سیٹ لنک بھیج دیا گیا",
  passwordResetError: "ری سیٹ ناکام",
  passwordResetSuccess: "پاس ورڈ اپ ڈیٹ ہو گیا",
  changePasswordSuccess: "پاس ورڈ اپ ڈیٹ ہو گیا",
  changePasswordSuccessMessage: "آپ کا پاس ورڈ کامیابی سے تبدیل ہو گیا۔",
  changePasswordError: "پاس ورڈ تبدیل نہیں ہو سکا",
  changePasswordOtpSent: "تصدیقی کوڈ بھیج دیا گیا",
  changePasswordOtpError: "تصدیقی کوڈ نہیں بھیجا جا سکا",

  // Form fields
  email: "ای میل",
  emailPlaceholder: "اپنا ای میل درج کریں",
  emailOrPhone: "ای میل یا فون نمبر",
  emailOrPhonePlaceholder: "اپنا ای میل یا فون نمبر درج کریں",
  password: "پاس ورڈ",
  passwordPlaceholder: "اپنا پاس ورڈ درج کریں",
  confirmPassword: "پاس ورڈ کی تصدیق کریں",
  confirmPasswordPlaceholder: "اپنے پاس ورڈ کی تصدیق کریں",
  passwordsDoNotMatch: "پاس ورڈ میل نہیں کھاتے",

  // Buttons
  buttons: {
    signIn: "سائن ان",
    signUp: "سائن اپ",
    forgotPassword: "پاس ورڈ بھول گئے",
    resetPassword: "پاس ورڈ ری سیٹ کریں",
    backToLogin: "لاگ ان پر واپس جائیں",
  },

  // Standalone convenience keys (duplicates of nested keys for easier access)
  name: "نام",
  namePlaceholder: "نام درج کریں",
  statusLabel: "حالت",
  nameRequired: "نام درکار ہے",
  active: "فعال",
  inactive: "غیر فعال",
  createSuccess: "تصدیق کامیابی سے بنائی گئی",
  updateSuccess: "تصدیق کامیابی سے اپ ڈیٹ ہوئی",
  deleteSuccess: "تصدیق کامیابی سے حذف ہوئی",
  deleteConfirm: "کیا آپ واقعی اس تصدیق کو حذف کرنا چاہتے ہیں؟",

  // Registration — new fields
  mobilePhone: 'موبائل نمبر',
  mobilePhonePlaceholder: '+966 5XX XXX XXXX',
  telephone: 'ٹیلی فون',
  telephonePlaceholder: '+966 1XX XXX XXXX',
  vatNumber: 'وی اے ٹی نمبر',
  vatNumberPlaceholder: '3XXXXXXXXXX3',
  addressLine1: 'سڑک کا پتہ',
  addressLine1Placeholder: 'سڑک کا نام',
  houseNumber: 'عمارت نمبر',
  city: 'شہر',
  cityPlaceholder: 'مثال: ریاض',
  region: 'علاقہ',
  postalCode: 'پوسٹل کوڈ',
  country: 'ملک',
  selectCountry: 'ملک منتخب کریں',
  selectRegion: 'علاقہ منتخب کریں',
  vatSection: 'وی اے ٹی معلومات',
  crSection: 'کمرشل رجسٹریشن',
  crNumber: 'کمرشل رجسٹریشن نمبر',
  addressSection: 'پتہ',
  vatCertificate: 'وی اے ٹی سرٹیفکیٹ',
  vatCertificateHint: 'اپنا سرکاری وی اے ٹی سرٹیفکیٹ اپ لوڈ کریں (PDF یا تصویر)',
  crDocument: 'کمرشل رجسٹریشن',
  crDocumentHint: 'اپنا کمرشل رجسٹریشن سرٹیفکیٹ اپ لوڈ کریں (PDF یا تصویر)',
  selectCity: 'شہر منتخب کریں',
  chooseFile: 'فائل منتخب کریں',
  attachments: 'دستاویزات',
  attachmentsHint: 'اپنا وی اے ٹی سرٹیفکیٹ اور کمرشل رجسٹریشن اپ لوڈ کریں',
  addDocument: 'دستاویز شامل کریں',
  businessSegment: 'کاروباری شعبہ',
  customerSegment: 'کسٹمر سیگمنٹ',
  customerSegmentHint: 'وہ زمرہ منتخب کریں جو آپ کے کاروبار کی نوعیت کو بہترین انداز میں بیان کرتا ہو۔',
  selectSegment: 'سیگمنٹ منتخب کریں',
  segmentTransport: 'ٹرانسپورٹ',
  segmentPlants: 'پلانٹس',
  segmentBagCustomers: 'بیگ کسٹمرز',
  regionRiyadh: 'ریاض',
  regionMakkah: 'مکہ مکرمہ',
  regionMadinah: 'مدینہ منورہ',
  regionQassim: 'قصیم',
  regionEastern: 'مشرقی صوبہ',
  regionAsir: 'عسیر',
  regionTabuk: 'تبوک',
  regionHail: 'حائل',
  regionNorthernBorders: 'شمالی حدود',
  regionJazan: 'جازان',
  regionNajran: 'نجران',
  regionBahah: 'الباحہ',
  regionJawf: 'الجوف',
  accountInfo: 'اکاؤنٹ کی معلومات',
  companyDetails: 'کمپنی کی تفصیلات',
  companyDetailsSubtitle: 'اپنی کمپنی اور پتے کی تفصیلات درج کریں',
  nextStep: 'اگلا',
  back: 'واپس',

  // API error keys returned by the backend as i18n keys
  errors: {
    invalidCredentials: "ای میل/فون یا پاس ورڈ غلط ہے",
    accountLocked: "بہت زیادہ ناکام کوششوں کی وجہ سے آپ کا اکاؤنٹ مقفل کر دیا گیا ہے۔ پاس ورڈ ری سیٹ کریں یا منتظم سے رابطہ کریں۔",
    emailNotConfirmed: "آپ کے اکاؤنٹ کی ای میل کی تصدیق نہیں ہوئی",
    accountBlocked: "منتظم نے آپ کا اکاؤنٹ بلاک کر دیا ہے",
    accountInactive: "منتظم نے آپ کا اکاؤنٹ غیر فعال کر دیا ہے",
    noTenant: "آپ کا اکاؤنٹ ابھی کسی ادارے سے منسلک نہیں ہے",
    accountPending: "آپ کا اکاؤنٹ ابھی فعال نہیں ہے۔ براہ کرم فعال ہونے کا انتظار کریں۔",
    accountSuspended: "منتظم نے آپ کا اکاؤنٹ معطل کر دیا ہے",
    registerDisabled: "رجسٹریشن فی الحال غیر فعال ہے",
    emailAlreadyTaken: "ای میل یا صارف نام پہلے سے رجسٹرڈ ہے",
    phoneTaken: "فون نمبر پہلے سے رجسٹرڈ ہے",
    sapBusinessPartnerNumberTaken: "SAP بزنس پارٹنر نمبر پہلے سے رجسٹرڈ ہے",
    phoneInvalid: "براہ کرم درست سعودی موبائل نمبر درج کریں",
    vatCertificateRequired: "وی اے ٹی سرٹیفکیٹ فائل درکار ہے",
    crDocumentRequired: "کمرشل رجسٹریشن دستاویز درکار ہے",
    loginFailed: "لاگ ان ناکام ہوا۔ دوبارہ کوشش کریں۔",
    registrationFailed: "رجسٹریشن ناکام ہوئی۔ دوبارہ کوشش کریں۔",
    deleteAccountFailed: "اکاؤنٹ حذف کرنا ناکام ہوا۔ دوبارہ کوشش کریں۔",
    updateProfileFailed: "پروفائل اپ ڈیٹ ناکام ہوا۔ دوبارہ کوشش کریں۔",
    passwordChangeFailed: "پاس ورڈ تبدیل کرنا ناکام ہوا۔ دوبارہ کوشش کریں۔",
    verificationCodeFailed: "تصدیقی کوڈ کی درخواست ناکام ہوئی۔ دوبارہ کوشش کریں۔",
    passwordResetRequestFailed: "پاس ورڈ ری سیٹ کی درخواست ناکام ہوئی۔ دوبارہ کوشش کریں۔",
    passwordResetFailed: "پاس ورڈ ری سیٹ ناکام ہوا۔ دوبارہ کوشش کریں۔",
  },

  // API success keys returned by the backend as i18n keys
  success: {
    registrationPending: "رجسٹریشن موصول ہو گئی۔ سائن ان سے پہلے آپ کا اکاؤنٹ فعال کیا جائے گا۔",
  },

  // Account action results
  deleteAccountSuccess: "اکاؤنٹ حذف ہو گیا",
  deleteAccountFailed: "اکاؤنٹ حذف کرنا ناکام ہوا",
  updateProfileSuccess: "پروفائل اپ ڈیٹ ہو گئی",
  updateProfileSuccessDesc: "آپ کی تبدیلیاں محفوظ ہو گئی ہیں۔",
  updateProfileFailed: "پروفائل اپ ڈیٹ ناکام ہوئی",

  // Lockout
  accountLocked: "اکاؤنٹ مقفل ہو گیا۔ اپنا پاس ورڈ ری سیٹ کریں یا منتظم سے رابطہ کریں۔",
  attemptsRemaining: "اکاؤنٹ مقفل ہونے سے پہلے یہ آخری کوشش ہے۔",

  // Session timeout
  sessionExpired: "سیشن ختم ہو گیا",
  sessionExpiredMessage: "عدم سرگرمی کی وجہ سے آپ کو لاگ آؤٹ کر دیا گیا ہے۔",

  // Validation
  validation: {
    fullNameRequired: "پورا نام درکار ہے",
    companyNameRequired: "کمپنی کا نام درکار ہے",
    emailRequired: "درست ای میل درکار ہے",
    passwordMin: "پاس ورڈ کم از کم 6 حروف کا ہونا چاہیے",
    passwordMismatch: "پاس ورڈ میل نہیں کھاتے",
    agreeToTermsRequired: "آپ کو شرائط سے اتفاق کرنا ہوگا",
    currentPasswordRequired: "موجودہ پاس ورڈ درکار ہے",
    passwordRequired: "پاس ورڈ درکار ہے",
    passwordMinLength: "پاس ورڈ کم از کم 6 حروف کا ہونا چاہیے",
    passwordMaxLength: "پاس ورڈ 100 حروف سے زیادہ نہیں ہو سکتا",
    confirmPasswordRequired: "پاس ورڈ کی تصدیق درکار ہے",
    passwordsMismatch: "پاس ورڈ میل نہیں کھاتے",
    countryRequired: 'ملک درکار ہے',
    customerSegmentRequired: 'کسٹمر سیگمنٹ درکار ہے',
    vatNumberRequired: 'وی اے ٹی نمبر درکار ہے',
    vatCertificateRequired: 'وی اے ٹی سرٹیفکیٹ فائل درکار ہے',
    crNumberRequired: 'کمرشل رجسٹریشن نمبر درکار ہے',
    crDocumentRequired: 'کمرشل رجسٹریشن دستاویز درکار ہے',
    addressLine1Required: 'پتہ درکار ہے',
    houseNumberInvalid: 'عمارت نمبر زیادہ سے زیادہ 4 ہندسوں تک ہونا چاہیے',
    cityRequired: 'شہر درکار ہے',
    regionRequired: 'علاقہ درکار ہے',
    postalCodeRequired: 'پوسٹل کوڈ درکار ہے',
    postalCodeLength: 'پوسٹل کوڈ بالکل 5 حروف پر مشتمل ہونا چاہیے',
  },
}
